import { combineReducers } from "redux";
import contactUsReducer from "./contact_us/contactUsReducer";

const rootReducer = combineReducers({
  contact_us: contactUsReducer,
});

export default rootReducer;
